import React from 'react'
import Header from 'components/Header'
import ShortenerContainer from 'containers/ShortenerContainer'
import LinksContainer from 'containers/LinksContainer'
import ReduxToastr from 'react-redux-toastr'


const HomePage = () => (
    <div>
      <Header />
      <ShortenerContainer />

      <LinksContainer />

      <ReduxToastr
          timeOut={2010}
          newestOnTop={true}
          preventDuplicates={false}
          position="top-right"
          transitionIn="fadeIn"
          transitionOut="fadeOut"
          />

    </div>
);


export default HomePage;



// WEBPACK FOOTER //
// ./src/components/home/HomePage.jsx